<template>
    <div>
        <!--The inputs are plotData, plotOptions and plotLines-->
        <div v-if="chartPlotted">
            <apexchart ref="chart" :options="plotOptions" :series="plotData"></apexchart>
            <!--div class="row d-flex justify-content-center">
                <label class="form-check-label col-auto" v-for="(line,index) in plotLines" :key="index" >
                    <input 
                        type="checkbox" 
                        v-model="checkboxValues[line.name]" 
                        @change="toggleDataSeries(line.label,line.name, $event.target.checked)" 
                        class="form-check-input">
                            {{ line.label }} {{ checkboxValues[line] }}  
                </label>
            </div-->
        </div>
        <div class="row" v-else>
            <div class="col-12 mb-4">
                <div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
                    <div class="card-body text-center">
                        <b-spinner 
                            variant="primary" 
                            type="grow" 
                            font-scale="7.5" 
                            class="mb-2"
                        >
                        </b-spinner>
                        <h5 class="card-title" style="color:black">{{ $t("loading") }}</h5>
                        <p class="card-text" style="color:black">
                            {{ $t('chart-loading') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import ApexCharts from 'apexcharts';

export default {
    name: 'Plotter',
    props: {
        plotData: Array,
        plotOptions: Object,
        plotLines: Array,
        chartPlotted: Boolean
    },
    data() {
        return {
            chart: null,
            checkboxValues: {},
        };
    },
    watch: {
        chartPlotted(newVal) {
            if (newVal) {
                this.createChart();
                console.log('fire')
            }
        }
    },
    mounted(){
        //this.createChart()
    },
    methods: {
        toggleDataSeries(series,name,value) {
            if('chart' in this.$refs) { //toggles the series to be plotted
                this.$refs.chart.toggleSeries(series);
            }
            this.$set(this.checkboxValues, name, value); //updates the checkbox
        },
        createChart(){
            const options = {
                ...this.plotOptions,
                series: this.plotData ? this.plotData : null 
            }
            
            const canvas =  document.querySelector('#chart');

            if (!canvas) {
                console.error('Chart element not found');
                return;
            }

            this.chart = new ApexCharts(canvas,options)
            this.chart.render().catch((error) => {
                console.error('Error rendering chart:', error);
            });
           
        }
    },
}
</script>